import React from 'react';
import LoginForm from '../components/LoginForm';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet-async"; // ✅ Import Helmet

const Login = () => {
  return (
    <div>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Login | VisionBird Technologies</title>
        <meta
          name="description"
          content="Login to your VisionBird Technologies account to manage your projects and services."
        />
      </Helmet>

      <Navbar />
      <LoginForm />
      <Footer />
    </div>
  );
};

export default Login;